import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { CustomerForm } from '@/features/users/customers/CustomerForm';
import { Translation } from '@/hoslog-intl';
import { EditIcon } from '@/icons';
import { createFileRoute, useParams } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/users/customers/$customerId')({
  component: RouteComponent,
  loader: () => {
    return {
      crumb: <CrumbTitle id="userManagement.crumb.manageCustomerInfo" icon={EditIcon} />,
      title: <Translation id="userManagement.crumb.manageCustomerInfo" />,
    };
  },
});

function RouteComponent() {
  const { customerId } = useParams({ from: '/(app)/users/customers/$customerId' });

  return (
    <div className="bg-card p-8 rounded-lg !w-full">
      <CustomerForm customerId={customerId} />
    </div>
  );
}
